export const cleanSearchHighlight = (text: string) => {
  if (!text) return text;
  return text.replaceAll("<em>", "").replaceAll("</em>", "");
};
